import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchPhicsRequest, deletePhicRequest } from "../../../api/phic";
import { formatCurrency } from "../../../helpers/functions/currency.js";

class PHICTable extends Component {

  state = {
    data: null,
    error: null,
    loading: false
  };

  componentDidMount() {
    if (!this.state.data && this.props.selectedEffectiveDate)
      this.fetchPHICData()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.selectedEffectiveDate !== this.props.selectedEffectiveDate) {
      this.fetchPHICData();
    }
  }

  fetchPHICData(){
    this.setState({
      loading: true
    });
    fetchPhicsRequest(
      this.props.selectedEffectiveDate,
      result => this.setState({data: result, error: null, loading: false}),
      error => this.setState({error: error.message, loading: false})
    )
  };

  deletePHIC = (id) => {
    deletePhicRequest(
      id,
      result => this.fetchPHICData(),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );

  }

  render() {
    const { data } = this.state;
    const { selectedEffectiveDate } = this.props;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="PHIC Table"
                category="List of PHIC entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm('phic')}>
                      New Group
                    </CustomButtom>
                    {!!selectedEffectiveDate && <Table striped hover>
                      <thead>
                        <tr>
                          <th>Salary From</th>
                          <th>Salary To</th>
                          <th>Percentage Value</th>
                          <th>Employer Share</th>
                          <th>Employee Share</th>
                          <th>Monthly Premium</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ?
                          <td colSpan="6" style={{padding: "0"}}>
                            <div className="loader"></div>
                          </td> 
                          :
                          (data && data.length > 0) 
                          ? data.map(instance => {

                            const monthlyPremium = instance.isPercentage 
                              ? `${formatCurrency(instance.salaryFrom * (instance.percentageValue/100))} up to ${formatCurrency(instance.salaryTo * (instance.percentageValue/100))}`
                              : formatCurrency(instance.monthlyPremium);

                            const employerShare = instance.isPercentage 
                              ? `${formatCurrency((instance.salaryFrom * (instance.percentageValue/100) / 2))} up to ${formatCurrency((instance.salaryTo * (instance.percentageValue/100) / 2))}`
                              : formatCurrency(instance.employerShare);
                              
                            const employeeShare = instance.isPercentage 
                              ? `${formatCurrency((instance.salaryFrom * (instance.percentageValue/100) / 2))} up to ${formatCurrency((instance.salaryTo * (instance.percentageValue/100) / 2))}`
                              : formatCurrency(instance.employeeShare);

                            return (
                              <tr key={instance._id}>
                                <td>{(instance.salaryFrom || instance.salaryFrom === 0) ? formatCurrency(instance.salaryFrom) : "N/A"}</td>
                                <td>{formatCurrency(instance.salaryTo) || "N/A"}</td>
                                <td>{instance.percentageValue || "N/A"}</td>
                                <td>{employerShare || "N/A"}</td>
                                <td>{employeeShare || "N/A"}</td>
                                <td>{monthlyPremium || "N/A"}</td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToDetails('phic', instance._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <CustomButtom 
                                      bsStyle="info" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToEditForm('phic', instance._id)}
                                    >
                                      <i className="fa fa-edit" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.deletePHIC(instance._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )}
                          )
                          : (
                            <tr>
                              <td colSpan='6'>There are no instances in the database yet.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>}
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default PHICTable;
